import { STAGES } from '@fruuit/shared/vocab'
import { cn, statusLabel } from '@fruuit/ui'

/** The 5-step stage track (STAT-013): reached steps are filled; the label is always shown. */
export function StageTrack({ stage, compact = false }: { stage: string; compact?: boolean }) {
  const level = Math.max(0, (STAGES.values as readonly string[]).indexOf(stage))
  return (
    <div className="flex items-center gap-2" role="img" aria-label={`Stage: ${statusLabel(stage)}`}>
      <span className="flex gap-1" aria-hidden="true">
        {STAGES.values.map((s, index) => (
          <span
            key={s}
            className={cn(
              'rounded-full',
              compact ? 'size-2' : 'size-3',
              index <= level ? 'bg-teal' : 'bg-line-strong',
            )}
          />
        ))}
      </span>
      <span className={cn('text-ink-soft', compact ? 'text-xs' : 'text-sm')}>
        {statusLabel(stage)}
      </span>
    </div>
  )
}
